export default __webpack_public_path__ + "static/media/project1-p3.fc76a5f0.png";